"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));

var _box = _interopRequireDefault(require("./box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint react/no-danger: 0 */

/**
 * This component display a content box with only text.
 *
 * @param contentBox
 * @returns {*}
 * @constructor
 */
var TextBox = function TextBox(_ref) {
  var contentBox = _ref.contentBox;
  return /*#__PURE__*/_react["default"].createElement(_box["default"], {
    className: "text-box"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _draftjsToHtml["default"])(contentBox.text)
    }
  }));
};

exports.TextBox = TextBox;
TextBox.propTypes = {
  contentBox: _propTypes["default"].shape({
    mediaUrl: _propTypes["default"].string,
    mediaPosition: _propTypes["default"].string,
    media: _propTypes["default"].bool,
    text: _propTypes["default"].oneOfType([_propTypes["default"].shape({
      blocks: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired
    }), _propTypes["default"].string]),
    category: _propTypes["default"].string,
    id: _propTypes["default"].number
  })
};
TextBox.defaultProps = {
  contentBox: null
};
var _default = TextBox;
exports["default"] = _default;